
export const serverTypeData = [
    { name: "Serveur LoRaWAN AVOB", id: "avoblorawanserver"},
    { name: "Serveur LoRaWAN Orange", id: "orangelorawanserver"},
    { name: "Hydrelis", id: "hydrelis"},
    { name: "Serveur FTP", id: "ftpserver"},
    { name: "Serveur LoRaWAN Wiotys", id: "wiotys"},
];

export const ftpprotocoleData = [
    { name: "FTP", id: "ftp"},
    { name: "SFTP", id: "sftp"},
];

export const statusData = [
    { name: "", id: 0},
    { name: "Problème de configuration du connecteur", id: -1},
    { name: "Problème sur le serveur LoRa", id: -3},
    { name: "Problème non connu", id: -2},
    { name: "OK", id: 1},
]